import { __assign, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { BadgeContainer } from "./styles";
import { useTheme } from "styled-components";
import { getBrighterColor } from "../../utils/functions";
export var Badge = forwardRef(function Badge(_a, ref) {
    var _b = _a.customColor, customColor = _b === void 0 ? "primary" : _b, _c = _a.variant, variant = _c === void 0 ? "default" : _c, children = _a.children, props = __rest(_a, ["customColor", "variant", "children"]);
    var theme = useTheme();
    var variantsChanges = {
        default: "",
        outlined: "\n      background-color: transparent;\n      color: ".concat(theme.colors[customColor].default, ";\n      border-color: ").concat(theme.colors[customColor].default, ";\n\n      svg {\n        fill: ").concat(theme.colors[customColor].default, ";\n      }\n    "),
        tonal: "\n      background-color: ".concat(getBrighterColor(theme.colors[customColor].default, 70), ";\n      color: ").concat(theme.colors.neutral.darker, ";\n      border-color: transparent;\n\n      svg {\n        fill: ").concat(theme.colors[customColor].default, ";\n      }\n    "),
    };
    return (_jsx(BadgeContainer, __assign({ "$customColor": customColor, variant: variantsChanges[variant], ref: ref }, props, { children: children })));
});
//# sourceMappingURL=index.js.map